import setFilters from 'store/reducer-utils/setFilters'
import { updateObject } from 'utils/updateObject'
import {
  DROP_LIST,
  REMOVE_FROM_LIST,
  SEEN,
  SET_ARCHIVE_PROCESSING_IDS,
  SET_BENCHMARKS,
  SET_FILTER,
  SET_NOTIFICATIONS,
  UPDATE,
} from 'modules/Recommendations/Benchmarks/types'

const initialState = {
  notifications: 0,
  archive: {
    processingIds: [],
  },
  loading: true,
  loaded: false,
  data: [],
  pagination: {
    offset: 0,
    limit: 50,
    total: 0,
  },
  filters: null,
}

const setBenchmarks = (state, { payload }) =>
  updateObject(state, {
    ...payload,
    data: [...state.data].concat(payload.data),
    loading: false,
    loaded: true,
  })

const update = (state, { payload }) => updateObject(state, payload)

const dropList = (state) =>
  updateObject(state, {
    data: [],
    pagination: {
      offset: 0,
      limit: 50,
      total: 0,
    },
    loading: true,
  })

const removeFromList = (state, { payload }) =>
  updateObject(state, {
    data: state.data.filter((item) => !payload.includes(item.id)),
  })

const setSeen = (state, { payload }) =>
  updateObject(state, {
    notifications: state.notifications - 1,
    data: state.data.map((item) =>
      payload.includes(item.id)
        ? {
            ...item,
            is_new: false,
          }
        : item,
    ),
  })

const benchmarksSetFilter = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const setArchiveProcessingIds = (state, { payload }) => {
  return updateObject(state, {
    archive: {
      processingIds: payload,
    },
  })
}

const setNotifications = (state, { payload }) => {
  return updateObject(state, {
    notifications: payload,
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE:
      return update(state, action)
    case SET_BENCHMARKS:
      return setBenchmarks(state, action)
    case SET_FILTER:
      return benchmarksSetFilter(state, action)
    case SET_ARCHIVE_PROCESSING_IDS:
      return setArchiveProcessingIds(state, action)
    case SEEN:
      return setSeen(state, action)
    case REMOVE_FROM_LIST:
      return removeFromList(state, action)
    case DROP_LIST:
      return dropList(state, action)
    case SET_NOTIFICATIONS:
      return setNotifications(state, action)

    default:
      return state
  }
}

export default reducer
